import React from 'react'
import DiscardIcon from 'client/utils/icons/discard-icon'
import SaveIcon from 'client/utils/icons/save-icon'
import ScanBarcodeIcon from 'client/utils/icons/scan-barcode-icon'
import UploadIcon from 'client/utils/icons/upload-icon'
import { DcButton, DcFlexBox } from 'pixel-base'
import { env } from 'shared/env'
import CompletedIcon from 'utils/icons/completed-icon'
import PencilIcon from 'utils/icons/pencil-icon'
import PrintIcon from 'utils/icons/print-icon'

interface ActionButtonsProps {
  purchase_id: string
  isNewPurchase: boolean
  isViewMode: boolean
  isEditMode: boolean
  setShowScanner: (show: boolean) => void
  setShowUploadModal: (show: boolean) => void
  setDetailType: (type: string) => void
  setPurchaseId: (id: string) => void
  setFormEditAble: (editable: boolean) => void
  getAllSuppliers: () => void
  getAllCategories: () => void
  discardChanges: () => void
  updatePurchasesStatus: (id: string, status: any, message: string) => void
  currentWarehouse: () => string
}

export const ActionButtons: React.FC<ActionButtonsProps> = ({
  purchase_id,
  isNewPurchase,
  isViewMode,
  isEditMode,
  setShowScanner,
  setShowUploadModal,
  setDetailType,
  setPurchaseId,
  setFormEditAble,
  getAllSuppliers,
  getAllCategories,
  discardChanges,
  updatePurchasesStatus,
  currentWarehouse,
}) => {
  const baseURL = env.SERVER_ADDR
  const { token } = JSON.parse(
    localStorage.getItem('user_info') || '{token: null}',
  )

  return (
    <DcFlexBox justifyContent="flex-end" gap="10px">
      {purchase_id && (
        <>
          {isEditMode ? (
            <>
              <DcButton
                variant="outline-danger"
                size="sm"
                onClick={discardChanges}
                withIcon={true}
              >
                <DiscardIcon size={16} />
                <span>Discard Changes</span>
              </DcButton>
              <DcButton size="sm" type="submit" withIcon={true}>
                <SaveIcon size={16} />
                <span>Save Changes</span>
              </DcButton>
            </>
          ) : isViewMode ? (
            <>
              <DcButton
                variant="outline-primary"
                onClick={() => {
                  window.open(
                    `${baseURL}api/v2/print/purchases/${token}/${purchase_id}`,
                  )
                }}
                size="sm"
              >
                <PrintIcon size={16} /> &nbsp; Print
              </DcButton>
              <DcButton
                variant="outline-success"
                size="sm"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '5px',
                }}
                onClick={() => {
                  updatePurchasesStatus(
                    purchase_id,
                    {
                      status: 'Completed',
                    },
                    `Marking Complete will update the stock counts in the warehouse ${currentWarehouse()}`,
                  )
                }}
              >
                <CompletedIcon size={16} /> <span>Mark Complete</span>
              </DcButton>
            </>
          ) : null}
        </>
      )}
      {isViewMode ? (
        <DcButton
          size="sm"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '5px',
          }}
          onClick={() => {
            setDetailType('edit')
            setPurchaseId(purchase_id)
            setFormEditAble(true)
            getAllSuppliers()
            getAllCategories()
          }}
        >
          <PencilIcon size={16} />
          <span>Edit</span>
        </DcButton>
      ) : (
        <>
          {(isNewPurchase || isEditMode) && (
            <>
              <DcButton
                size="sm"
                variant="outline-success"
                onClick={() => setShowScanner(true)}
                withIcon={true}
              >
                <ScanBarcodeIcon size={16} />
                Scan Barcode
              </DcButton>
              <DcButton
                size="sm"
                variant="outline-info"
                onClick={() => setShowUploadModal(true)}
                withIcon={true}
              >
                <UploadIcon size={16} />
                <span>Upload CSV</span>
              </DcButton>
            </>
          )}
          {isNewPurchase && (
            <DcButton size="sm" type="submit" withIcon={true}>
              <SaveIcon size={16} />
              <span>Save Draft</span>
            </DcButton>
          )}
        </>
      )}
    </DcFlexBox>
  )
}
